import { apiEndpoint } from "../utils/env";

async function fetchWithAuth(url, token, options = {}) {
  const headers = { ...(options.headers || {}) };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  headers["Content-Type"] = headers["Content-Type"] || "application/json";
  const res = await fetch(url, { ...options, headers });
  const txt = await res.text();
  let json = null;
  try {
    json = txt ? JSON.parse(txt) : null;
  } catch {
    json = txt;
  }
  if (!res.ok) {
    const errMsg =
      json && json.message
        ? json.message
        : typeof json === "string"
        ? json
        : res.statusText;
    const error = new Error(errMsg || `Request failed: ${res.status}`);
    error.status = res.status;
    throw error;
  }
  return json;
}

/** Returns all saved flows for the user's organization. */
export async function getFlows(token) {
  return fetchWithAuth(apiEndpoint("/api/Flow/all"), token, { method: "GET" });
}

/** Save (create or update) a flow. */
export async function saveFlow(token, flow) {
  return fetchWithAuth(apiEndpoint("/api/Flow/save"), token, {
    method: "POST",
    body: JSON.stringify(flow),
  });
}

/** Delete a flow by name. */
export async function deleteFlow(token, name) {
  return fetchWithAuth(
    apiEndpoint(`/api/Flow/${encodeURIComponent(name)}`),
    token,
    { method: "DELETE" }
  );
}

/**
 * Get list of available databases (for dynamic list steps).
 * Returns a plain string[] of database names.
 */
export async function getDatasourceDatabases(token) {
  return fetchWithAuth(apiEndpoint("/api/Flow/datasources/databases"), token, {
    method: "GET",
  });
}

/**
 * Get searchable fields for a database (for dynamic list steps).
 * Returns a plain string[] of field display names.
 */
export async function getDatasourceFields(token, dbName) {
  return fetchWithAuth(
    apiEndpoint(
      `/api/Flow/datasources/fields/${encodeURIComponent(dbName)}`
    ),
    token,
    { method: "GET" }
  );
}

/**
 * Execute a flow search.
 * @param {string} token - JWT bearer token
 * @param {object} ctx - accumulated flow context { key: value }
 * @param {object} searchConfig - flow search config (databases, fieldMappings, etc.)
 * @returns {Promise<DocItem[]>} - array of matching documents
 */
export async function executeFlowSearch(token, ctx, searchConfig) {
  return fetchWithAuth(apiEndpoint("/api/Flow/search"), token, {
    method: "POST",
    body: JSON.stringify({ context: ctx, searchConfig }),
  });
}
